export interface IInsuranceCarrier {
    id: number,
    carrierName: string,
    isMedicare: boolean,
    paysOutOfStateDonorSurgeon: boolean,
    isPrivate: boolean
}